import { Big } from 'big.js';
import { bigToString, CorridorLevel, MathUtils, parseBig } from 'quote-domain-core';
import { singleton } from 'tsyringe';

@singleton()
export class CorridorLevelService {
    public addingPrice(corridorLevel: CorridorLevel, price: Big): void {
        Object.assign(corridorLevel, {
            max: bigToString(new Big(corridorLevel.max).add(price)),
            min: bigToString(new Big(corridorLevel.min).add(price))
        });
    }

    public addingPriceToMaxValue(corridorLevel: CorridorLevel, price: Big): void {
        Object.assign(corridorLevel, { max: bigToString(new Big(corridorLevel.max).add(price)) });
    }

    public multiply(corridorLevel: CorridorLevel, value: Big): void {
        Object.assign(corridorLevel, {
            max: bigToString(parseBig(corridorLevel.max).mul(value)),
            min: bigToString(parseBig(corridorLevel.min).mul(value))
        });
    }

    public multiplyQuantity(corridorLevel: CorridorLevel, quantity: Big): void {
        Object.assign(corridorLevel, {
            max: bigToString(MathUtils.maxBig(parseBig(corridorLevel.max).mul(quantity), new Big(0))),
            min: bigToString(MathUtils.maxBig(parseBig(corridorLevel.min).mul(quantity), new Big(0)))
        });
    }

    public adding(corridorLevel: CorridorLevel, max: string, min: string): void {
        Object.assign(corridorLevel, {
            max: bigToString(parseBig(corridorLevel.max).plus(parseBig(max))),
            min: bigToString(new Big(corridorLevel.min).add(min))
        });
    }
}
